export default "__VITE_ASSET__$rk7_8Am__"